function normalizeGraphQLValidationError(errorSet, error, parentPath) {
  const path = [...parentPath, error.key];
  if (error.messages) {
    const pathString = path.join('.');
    errorSet = {
      ...errorSet,
      [pathString]: error.messages || [],
    };
  }
  if (!error.errors) {
    return errorSet;
  }
  // eslint-disable-next-line no-use-before-define
  return normalizeGraphQLValidationErrorSet(errorSet, error.errors, path);
}

function normalizeGraphQLValidationErrorSet(errorSet, errors, parentPath) {
  return errors.reduce(
    (newErrorSet, error) => normalizeGraphQLValidationError(newErrorSet, error, parentPath || []),
    errorSet
  );
}

export default function handleMutation(promise, mutatationName) {
  return promise
    .then(({ data }) => {
      const result = (data && data[mutatationName]) || {
        status: 500,
        message: 'Unexpected Error',
        errors: undefined,
      };
      let isSuccessful = result.status < 300;
      let errors = null;
      if (result.errors != null && result.errors.length > 0) {
        isSuccessful = false;
        errors = normalizeGraphQLValidationErrorSet({}, result.errors, []);
      }
      return { ...result, isSuccessful, errors };
    })
    .catch((error) => ({ isSuccessful: false, status: 500, message: error, errors: null }));
}
